import React, { Component } from 'react';
import { Icon, Segment, Table, Dropdown, Container, Button, Checkbox } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import { withTranslation } from 'react-i18next';
import 'moment/locale/tr';

class Analytic extends Component {
	state = {
		filterType: false,
		filterAgent: false,
		loading: true,
		start_date: this.props.start_date,
		end_date: this.props.end_date,
		today: moment(),
		group: ['agent'],
		value: [5, 4, 3, 2, 1],
		agent_role: this.props.access.user.loggedUserObj.role,
		agent_id: this.props.access.user.loggedUserObj.extra.user_id,
		pid: /* '02cc63330cd0808f87c54ad9dd94b74a' ||  */ this.props.product.live.settings.live.token,
		selectedAgent: 'all',
		selectedDate: 'daily',
		groupBy: 'agent',
		selectedTopic: 'all',
		column: 'rate',
		botId: '',
		direction: 'descending',
		dataloading: true,
		displayName: 'developer',
		selectedBarStyle: 'line',
		loadingGraph: true,
		rate: 'all',
		selectedPlatform: 'web',
		selectedWatsonsGroup: 'all',
	};
	componentDidMount() {
		this.getIntents();
		this.getIntentData();
	}
	async getIntentData() {
		let { start_date, end_date } = this.props;
		await fetch('https://log.yapaytech.com/live/getWaitingInfoIntentForward', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				pid: this.state.pid,
				select: '*',
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let result = data && data.result && data.result.result;
				let web_conversations = _.filter(result, { platform: 'web' });
				let whatsapp_conversations = _.filter(result, { platform: 'whatsapp' });
				let group_by_intent = _.orderBy(
					_.groupBy(web_conversations, (it) => it.extra && it.extra.starting_forward_intent),
					(it) => it.length,
					'desc'
				);
				let group_by_intent_whatsapp = _.orderBy(
					_.groupBy(whatsapp_conversations, (it) => it.extra && it.extra.starting_forward_intent),
					(it) => it.length,
					'desc'
				);
				console.log('group_by_intent', web_conversations, group_by_intent, whatsapp_conversations, group_by_intent_whatsapp);
				this.setState({
					group_by_intent,
					group_by_intent_whatsapp,
					web_conversations,
					whatsapp_conversations,
					waitingData: data && data.result && data.result.result,
					waitingTotalData: data && data.result && data.result.total,
					loadingwaitingTotalData: false,
					loading: false,
				});
			});
	}
	async getIntents() {
		await fetch('/api/dahi/message/getIntents')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				console.log('intents', data);
				let intents = data && data.result;
				let whatsapp_intents = data && data.whatsapp_intents;
				this.setState({ intents, whatsapp_intents });
			});
	}
	componentDidUpdate(oldProps, oldState) {
		const check_list = [/* 'start_date', 'end_date',  */ 'selectedAgent', 'value', 'selectedPlatform', 'selectedWatsonsGroup', 'newDataToggle'];
		for (let i = 0; i < check_list.length; i++) {
			const key = check_list[i];
			if (key === 'start_date' || key === 'end_date' || key === 'newDataToggle') {
				if (this.props[key] !== oldProps[key]) {
					this.getIntentData();
					break;
				}
			}
			if (this.state[key] !== oldState[key]) {
				this.getIntentData();
				break;
			}
		}
	}
	getData() {
		this.setState({ loading: true });
		let { pid, selectedAgent, selectedPlatform, selectedWatsonsGroup, productAgentList } = this.state;
		let { start_date, end_date } = this.props;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let filter = {};
		let showingproductAgentList2;
		if (selectedWatsonsGroup !== 'all') {
			showingproductAgentList2 = _.filter(productAgentList, (it) => it.group === selectedWatsonsGroup);
		} else {
			showingproductAgentList2 = productAgentList;
		}
		let group_agents = _.map(showingproductAgentList2, (it) => it.id);
		if (selectedAgent === 'all') {
			if (selectedWatsonsGroup !== 'all') {
				filter = { type: ['closed'], pid, agent: group_agents };
			} else {
				filter = { type: ['closed'], pid };
			}
		} else {
			filter = { type: ['closed'], pid, agent: selectedAgent };
		}
		if (selectedPlatform !== 'all') {
			if (pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && selectedPlatform === 'web') {
				_.set(filter, 'platform', ['web', 'flo']);
			} else {
				_.set(filter, 'platform', selectedPlatform);
			}
		}
		fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter,
				select: [],
				group: ['type', 'agent', 'rate', 'cid', 'date', 'platform', 'topic', 'comment', 'selectable_comment'],
				pairs: {
					agent: 'select1',
					topic: 'select2',
					select1: 'select1',
					cid: 'select4',
					rate: 'select5',
					platform: 'platform',
					comment: 'select7',
					selectable_comment: 'select3',
				},
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let list = _.filter(data.result, (o) => o.rate);
				let modify_list = _.map(list, (it) => {
					it.platform = pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && it.platform === 'web' ? 'flo' : it.platform;
					return it;
				});
				//let groupedList = _.groupBy(modify_list, (it) => `${it.rate}-${it.selectable_comment}`);

				let groupedList = _.orderBy(
					_.map(
						_.groupBy(modify_list, (it) => '' + it.rate),
						(o) => ({
							rate: o[0].rate,
							length: o.length,
							rates: _.map(
								_.groupBy(o, (e) => e.selectable_comment),
								(t) => ({ comment: t[0].selectable_comment, length: t.length })
							),
						})
					),
					(j) => _.parseInt(j.rate),
					'desc'
				);
				console.log('groupedList', groupedList);
				this.setState({ list: modify_list, groupedList });
			});
		fetch('/api/dahi/message/getLiveChat', {})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					productAgentList:
						data.result &&
						data.result.agents &&
						_.filter(data.result.agents, function (it) {
							return it.type !== 'viewer';
						}),
					botId: data.result && data.result.bot.bid,
					bot_id: data.result && data.result.bot.id,
					staticOptions: data.result && data.result.staticOptions,
					productOldAgentList: data.result && data.result.old_agents,
					closeTags: data.result && data.result.staticOptions && data.result.staticOptions.closeTags,
					chat_groups: data.result && data.result.staticOptions && data.result.staticOptions.groups,
					loading: false,
				});
			});
	}
	handleFilterChange = (e, { text, value }) => this.setState({ selectedAgent: value, selectedAgentName: text });
	handleFilterChangeRate = (e, { text, value }) => this.setState({ rate: value });
	handleChange = (e, { name, value }) => this.setState({ [name]: value });
	handleFilterCheck(value) {
		let array = this.state.value || [];
		let exists = _.includes(array, value);
		let valueArr = exists ? _.filter(array, (it) => it !== value) : _.concat([], array, value);
		this.setState({ value: valueArr });
	}
	handleSort = (clickedColumn) => () => {
		const { column, direction } = this.state;
		if (column !== clickedColumn) {
			this.setState({
				column: clickedColumn,
				direction: 'descending',
			});

			return;
		}
		this.setState({
			direction: direction === 'ascending' ? 'descending' : 'ascending',
		});
	};
	render() {
		let { t, platformList, product } = this.props;
		let {
			loading,
			list,
			value,
			search_text,
			column,
			direction,
			selectedPlatform,
			selectedWatsonsGroup,
			chat_groups,
			groupedList,
			selectedAgent,
			group_by_intent,
			group_by_intent_whatsapp,
			web_conversations,
			whatsapp_conversations,
			intents,
			whatsapp_intents,
		} = this.state;
		let productAgentList = this.state.productAgentList;
		let dropAgentList = _.map(productAgentList, function (it) {
			return { text: it.developer, key: it.id, value: it.id };
		});
		dropAgentList = _.concat({ text: t('allAgent'), key: 'all', value: 'all' }, dropAgentList);
		let showingproductAgentList2;
		if (selectedWatsonsGroup !== 'all') {
			showingproductAgentList2 = _.filter(productAgentList, (it) => it.group === selectedWatsonsGroup);
		} else {
			showingproductAgentList2 = productAgentList;
		}
		let filteredList = _.filter(list, (o) => _.includes(value, parseInt(o.rate)));
		if (search_text !== '') {
			let regex = new RegExp(search_text);
			filteredList = _.filter(filteredList, (o) => regex.test(o.cid));
		}
		filteredList = _.orderBy(filteredList, [column], [direction === 'ascending' ? 'asc' : 'desc']);
		if (loading)
			return (
				<Container>
					<Segment style={{ marginBottom: '20px' }}>
						<Page.Loader></Page.Loader>
					</Segment>
				</Container>
			);
		return (
			<Container>
				<Segment style={{ marginBottom: '20px' }}>
					<div style={{ display: 'flex' }}>
						<Dropdown
							selection
							options={platformList}
							value={selectedPlatform}
							floating
							labeled
							button
							icon="filter"
							className="icon"
							name="selectedPlatform"
							onChange={(e, { name, value }) => this.setState({ selectedPlatform: value })}
						/>
						{/* {product &&
						product.live &&
						product.live.settings &&
						product.live.settings.analyticView &&
						product.live.settings.analyticView.watsonsgroups ? (
							<Dropdown
								selection
								options={watsons_groups}
								value={selectedWatsonsGroup}
								floating
								labeled
								button
								icon="filter"
								className="icon"
								name="selectedWatsonsGroup"
								onChange={(e, { name, value }) => this.setState({ selectedWatsonsGroup: value })}
							/>
						) : (
							''
						)} */}
						{/* <Dropdown
							options={dropAgentList}
							selection
							defaultValue={selectedAgent || dropAgentList[0].value}
							icon="filter"
							floating
							labeled
							button
							className="icon"
							onChange={this.handleFilterChange}
						></Dropdown> */}
					</div>

					<Table sortable>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>{t('name')}</Table.HeaderCell>
								<Table.HeaderCell>{t('count')}</Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						{selectedPlatform === 'web' ? (
							<Table.Body>
								<Table.Row style={{ backgroundColor: '#ccc' }}>
									<Table.Cell>Web Bot</Table.Cell>
									<Table.Cell>{web_conversations && web_conversations.length}</Table.Cell>
								</Table.Row>

								{_.map(group_by_intent, (it) => {
									let intent_info =
										(it[0] && it[0].extra && it[0].extra.starting_forward_intent && it[0].extra.starting_forward_intent.split('_')) ||
										'undefined';
									let intent = _.find(intents, (o) => o._id === intent_info[0]);
									let intent_name = (intent && intent.name) || '';
									let buttons =
										(intent && intent.action && intent.action.message && intent.action.message[0] && intent.action.message[0].buttons) ||
										(intent && intent.action && intent.action.message && intent.action.message[1] && intent.action.message[1].buttons);
									let button = buttons && buttons.length && intent_info && intent_info[1] && buttons[parseInt(intent_info[1])];
									return (
										<Table.Row>
											<Table.Cell>
												{intent_info === 'undefined'
													? 'Bilgi Yok'
													: intent
													? intent_name + (button ? ` -> ${button.title}` : '')
													: intent_info}
											</Table.Cell>
											<Table.Cell>{it.length}</Table.Cell>
										</Table.Row>
									);
								})}
							</Table.Body>
						) : (
							''
						)}
						{selectedPlatform === 'whatsapp' ? (
							<Table.Body>
								<Table.Row style={{ backgroundColor: '#ccc' }}>
									<Table.Cell>WhatsApp Bot</Table.Cell>
									<Table.Cell>{whatsapp_conversations && whatsapp_conversations.length}</Table.Cell>
								</Table.Row>

								{_.map(group_by_intent_whatsapp, (it, i) => {
									let intent_info =
										(it[0] && it[0].extra && it[0].extra.starting_forward_intent && it[0].extra.starting_forward_intent.split('_')) ||
										'undefined';
									let intent = _.find(whatsapp_intents, (o) => o._id === intent_info[0]);
									let intent_name = (intent && intent.name) || '';
									let buttons =
										(intent && intent.action && intent.action.message && intent.action.message[0] && intent.action.message[0].buttons) ||
										(intent && intent.action && intent.action.message && intent.action.message[1] && intent.action.message[1].buttons);
									let button = buttons && buttons.length && intent_info && intent_info[1] && buttons[parseInt(intent_info[1])];
									return (
										<Table.Row>
											<Table.Cell>
												{intent_info === 'undefined'
													? 'Bilgi Yok'
													: intent
													? intent_name + (button ? ` -> ${button.title}` : '')
													: intent_info}
											</Table.Cell>
											<Table.Cell>{it.length}</Table.Cell>
										</Table.Row>
									);
								})}
							</Table.Body>
						) : (
							''
						)}
					</Table>
				</Segment>
			</Container>
		);
	}
}

const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product });
export default connect(stateToProps)(withTranslation()(Analytic));
